import { render } from "./cabinaAdmin.vue?vue&type=template&id=25652ce6"
import script from "./cabinaAdmin.vue?vue&type=script&lang=js"
export * from "./cabinaAdmin.vue?vue&type=script&lang=js"

import "./cabinaAdmin.vue?vue&type=style&index=0&id=25652ce6&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__